import {useTranslation} from "react-i18next";
import {EnumInterface, SelectElementModelFE,} from "../../../api/types/generic";
import {useFormContext} from "react-hook-form";
import {FormReportModel} from "../../../api/types/report";
import {useTypesRepository} from "../../../api/repositories/TypesRepository";
import {useRecoilState} from "recoil";
import {datesAtom, monthsAtom, reportsAtom,} from "../../../state/reportRecoil";
import {useEffect} from "react";
import {fromEnumToFe} from "../../../utils";
import IncomingReservationsForm from "./IncomingReservationsForm";
import Grid from "@mui/material/Grid";
import {useReportsRepository} from "../../../api/repositories/ReportRepository";
import NumberOfReservationsForm from "./NumberOfReservationsForm";
import CompetitorsBenchmarkForm from "./CompetitorsBenchmarkForm";
import NumberOfDaysOfReservationsForm from "./NumberOfDaysOfReservationsForm";
import AverageRpdForm from "./AverageRpdForm";
import RevenuesForm from "./RevenuesForm";
import NumberOfReservationsCarGroupsForm from "./NumberOfReservationCarGroupsForm";
import UtilizationAndAvailabilityForm from "./UtilizationAndAvailabilityForm";
import {PRICING_REPORTS} from "../../../constants";

type Props = {
    activeStep: number;
};

const ReportFormsHandler = ({activeStep}: Props) => {
    const dateTypes: EnumInterface = {
        PICK_UP: "PICK UP",
        DROP_OFF: "DROP OFF",
    };

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    //USE FORM CONTEXT
    const {register, watch, reset} = useFormContext<FormReportModel>();

    //USE RECOIL ATOM
    const [reportsList, setReportsList] = useRecoilState(reportsAtom);
    const [, setMonthsList] = useRecoilState(monthsAtom);
    const [, setDates] = useRecoilState(datesAtom);

    //USE CUSTOM HOOK
    const {getReportsType} = useTypesRepository();
    const {getMonthsEnum} = useReportsRepository();

    const getStaticContents = async () => {
        try {
            const mothsList: string[] = await getMonthsEnum();
            setMonthsList(mothsList);
            const dateType: EnumInterface = dateTypes;
            const datesType: SelectElementModelFE[] = fromEnumToFe(dateType);
            setDates(datesType);
        } catch (e) {
        }
    };

    // Use Effect
    useEffect(() => {
        getStaticContents();
        // eslint-disable-next-line
    }, []);

    const renderReportsForm = () => {
        switch (watch("type")?.label) {
            case PRICING_REPORTS.RPD_INCOMING_RESERVATIONS:
                return <IncomingReservationsForm readOnly={false}/>;
            case PRICING_REPORTS.COMPETITORS_BENCHMARK:
                return <CompetitorsBenchmarkForm readOnly={false}/>;
            case PRICING_REPORTS.RESERVATIONS_NUMBER:
                return <NumberOfReservationsForm readOnly={false}/>;
            case PRICING_REPORTS.RESERVATIONS_PER_DAY:
                return <NumberOfDaysOfReservationsForm readOnly={false}/>;
            case PRICING_REPORTS.AVERAGE_RPD:
                return <AverageRpdForm readOnly={false}/>;
            case PRICING_REPORTS.REVENUES:
                return <RevenuesForm readOnly={false}/>;
            case PRICING_REPORTS.RESERVATIONS_BOOKING_DATE_AND_CARGROUPS:
                return <NumberOfReservationsCarGroupsForm readOnly={false}/>;
            case PRICING_REPORTS.UTILIZATION_AVAILABILITY:
                return <UtilizationAndAvailabilityForm readOnly={false}/>;
            default:
                break;
        }
    };

    return (
        <Grid container>
            {/* SWITCH PER RENDERIZZARE I VARI FORM */}
            {activeStep === 1 ? renderReportsForm() : ""}
        </Grid>
    );
};

export default ReportFormsHandler;
